import { AddInsuranceFormModalContext } from "@/contexts/AddInsuranceFormModalContext"
import { useContext } from "react"

export const useAddInsuranceFormModalContext = () => {
  const context = useContext(AddInsuranceFormModalContext)

  if (!context) throw new Error('useAddInsuranceFormModalContext has to bee wrapped by AddInsuranceFormModalContextPropvider component')

  return context
}